<template>
  <div class="d-flex flex-column gap-12 mb-6">
  
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text d-flex justify-space-between">
          <div class="txt-head black--text mb-2">
            <span class="theme-color-one">ส่วนที่ 4 :</span> Output Outcome
            Impact / ตัวชี้วัดความสำเร็จ
          </div>

          <v-btn icon :class="{ rotate180: OOIExpanded }" @click="OOIExpanded = !OOIExpanded">
            <Iconify icon="material-symbols:keyboard-arrow-down" color="var(--theme-color-seven)"></Iconify>
          </v-btn>
        </div>
        <!-- Form 1 -->
        <div class="card-part expandable pt-0 justify-space-between d-flex" :class="{ 'expanded mt-3': OOIExpanded }">
          <div class="txt-head black--text mb-5">
            1. ตัวชี้วัดความสำเร็จ
            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
          </div>
          <div>
            <Button v-if="!isFinal" theme="6" :disabled="partTwoEditMode" @onClick="addNewBudget">
              + เพิ่มรายละเอียดงบประมาณ
            </Button>
          </div>
        </div>
        <div class="card-part">
          <div v-if="form.dynamic_kpi && form.dynamic_kpi.length > 0" class="d-flex flex-column gap-16">
            <divcard v-for="(item, i) in form.dynamic_kpi" :key="i"
              class="d-flex justify-space-between align-center black--text gap-12">
              <div style="width: 8%; align-self: start">
                <v-btn v-if="!isFinal" small icon @click="editBudget(i)">
                  <Iconify icon="material-symbols:edit" color="var(--theme-color-seven)"></Iconify>
                </v-btn>
                <v-btn v-if="!isFinal" small icon @click="deleteBudget(i)">
                  <Iconify icon="material-symbols:delete" color="var(--theme-color-seven)"></Iconify>
                </v-btn>
              </div>
              <div style="width: 15%; align-self: start">
                {{ "ตัวชี้วัดที่ " + item.name }}
              </div>
              <div style="width: 47%; align-self: start">
                <div>
                  <div class="mb-3">
                    {{ item?.unit }}
                  </div>
                  <div v-for="(detail, ind) in item.sub" :key="ind">
                    {{ detail.name }}
                  </div>
                  <!-- <div class="mt-3">รวม</div> -->
                </div>
              </div>
              <div class="" style="width: 12%">
                <div>
                  <div class="mb-3" style="visibility: hidden">hidden</div>
                  <div v-for="(detail, ind) in item.sub" :key="ind">
                    {{ formatNumber(detail.amount, 2) }}
                  </div>
                  <!-- <div class="mt-3">{{ formatNumber((item?.sub).reduce((sum, item) => sum + Number(item.amount || 0), 0),2) }}</div> -->
                </div>
              </div>
              <div class="" style="width: 19%">
                <div>
                  <div class="mb-3" style="visibility: hidden">hidden</div>
                  <div v-for="(detail, ind) in item.sub" :key="ind">
                    {{ detail.unit }}
                  </div>
                  <!-- TODO currency can not sum -->
                  <!-- <div class="mt-3">{{ item?.sub[0]?.unit }}</div> -->
                </div>
              </div>
            </divcard>
          </div>
          <div v-else class="no-plan-item">ไม่มีข้อมูล</div>
        </div>

        <div v-if="partTwoEditMode && !isFinal" id="part-two-edit2" class="card-part">
          <div class="d-flex gap-16">
            <div>
              <div class="black--text mb-2">ตัวชี้วัดที่</div>

              <TextField
                theme="3"
                style="width: 400px"
                :value="getNextIndicatorNumber()"
                readonly
                disabled
              ></TextField>
            </div>

            <div>
              <div class="black--text mb-2">หัวข้อ</div>

              <TextField theme="3" style="width: 400px" :value="tempBudget.unit" @onChange="tempBudget.unit = $event">
              </TextField>
            </div>
            <div class="d-flex align-center">
              <v-btn icon x-small style="background: var(--theme-color-two)" class="mt-1" @click="addBudgetDetail">
                <span class="font-type-bold txt-detail white--text">+</span>
              </v-btn>
            </div>
          </div>

          <div>
            <div class="d-flex flex-column">
              <div v-for="(item, i) in tempBudget.sub" :key="i" class="d-flex align-center gap-16">
                <div>
                  <div class="black--text mb-2">ข้อที่ {{ i + 1 }}</div>

                  <TextField theme="3" style="width: 400px" :value="item.name" @onChange="item.name = $event">
                  </TextField>
                </div>

                <div>
                  <div class="black--text mb-2">จำนวน</div>
                  <TextField
                    theme="3"
                    input-type="decimal"
                    :isFormat="true"
                    style="width: 400px"
                    :value="formatDisplayAmount(item.amount)"
                    placeholder="0"
                    @onChange="editDetailAmount(i, $event, 'amount')"
                  ></TextField>

                </div>

                <div>
                  <div class="black--text mb-2">หน่วย</div>
                  <TextField theme="3" :value="item.unit" @onChange="editDetailAmount(i, $event, 'currency')">
                  </TextField>
                </div>

                <v-btn v-if="tempBudget.sub.length > 1" icon x-small style="background: var(--theme-color-seven)"
                  class="mt-1" @click="tempBudget.sub.splice(i, 1)">
                  <span class="font-type-bold txt-detail white--text pb-1">x</span>
                </v-btn>
              </div>
            </div>
          </div>

          <div class="d-flex justify-end gap-16">
            <Button min-width="80px" theme="2" @onClick="partTwoEditMode = false">ยกเลิก
            </Button>

            <Button min-width="80px" theme="6" @onClick="saveBudget">ยืนยัน
            </Button>
          </div>
        </div>
      </div>
    </divcard>
    <!-- 4. หากไม่ได้เข้ารับบริการกับทางอุทยานวิทยาศาสตร์ภูมิภาค -->
    <divcard noPadding>
      <div class="card-part">
        <div>
          <div class="mb-5 d-flex justify-space-between" style="width: 100%; padding: 4px 24px">
            <span class="black--text txt-head">
              2. ผลผลิตและตัวชี้วัดความสำเร็จ
            </span>
            <v-btn icon :class="{ rotate180: OOI2Expanded }" @click="OOI2Expanded = !OOI2Expanded">
              <Iconify icon="material-symbols:keyboard-arrow-down" color="var(--theme-color-seven)"></Iconify>
            </v-btn>
          </div>
          <!-- <v-divider v-if="OOI2Expanded" class="mt-4 mb-8 "></v-divider> -->
          <div class="card-part expandable pt-0" :class="{ 'expanded ': OOI2Expanded }">
            <span class="black--text" style="padding: 12px 24px">
              ในเชิงเศรษฐกิจ
            </span>
            <TextArea style="padding: 12px 24px" theme="3" height="120" :value="form.indicator_economy"
              @onChange="setFormField('indicator_economy', $event)"></TextArea>
          </div>
        </div>
      </div>
    </divcard>
    <divcard noPadding>
      <div class="card-part">
        <div>
          <div class="mb-5 d-flex justify-space-between" style="width: 100%; padding: 4px 24px">
            <span class="black--text txt-head"> 3. ผลลัพท์ </span>
            <v-btn icon :class="{ rotate180: resultExpanded }" @click="resultExpanded = !resultExpanded">
              <Iconify icon="material-symbols:keyboard-arrow-down" color="var(--theme-color-seven)"></Iconify>
            </v-btn>
          </div>
          <!-- <v-divider v-if="resultExpanded" class="mt-4 mb-8 "></v-divider> -->
          <div class="card-part expandable pt-0" :class="{ 'expanded ': resultExpanded }">
            <div>
              <span class="black--text" style="padding: 12px 24px">
                ด้านเศรษฐกิจ
              </span>
              <TextArea style="padding: 12px 24px" theme="3" height="120" :value="form.result_economy"
                @onChange="setFormField('result_economy', $event)"></TextArea>
            </div>
            <div>
              <span class="black--text" style="padding: 12px 24px">
                ด้านสังคม
              </span>
              <TextArea style="padding: 12px 24px" theme="3" height="120" :value="form.result_society"
                @onChange="setFormField('result_society', $event)"></TextArea>
            </div>
            <div>
              <span class="black--text" style="padding: 12px 24px">
                ด้านสิ่งแวดล้อม
              </span>
              <TextArea style="padding: 12px 24px" theme="3" height="120" :value="form.result_environment"
                @onChange="setFormField('result_environment', $event)"></TextArea>
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <divcard v-if="isOIC" noPadding>
      <div class="card-part ">
        <div>
          <div class="mb-5 d-flex justify-space-between" style="width:100%; padding:4px 24px; ">
            <span class="black--text txt-head">
              4. ความคิดเห็น/ข้อเสนอแนะ
            </span>
            <v-btn icon :class="{ rotate180: OOI4Expanded }" @click="OOI4Expanded = !OOI4Expanded">
              <Iconify icon="material-symbols:keyboard-arrow-down" color="var(--theme-color-seven)"></Iconify>
            </v-btn>
          </div>
          <div class="card-part expandable pt-0" :class="{ 'expanded ': OOI4Expanded }">
            <TextArea style="padding:12px 24px;" theme="3" height="120" :value="form?.ops_comment"
              @onChange="setFormField('ops_comment', $event)"></TextArea>
          </div>
        </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField";
import TextArea from "../../../components/input/TextArea";
import SwitchInset from "../../../components/input/SwitchInset";
import OOILineField from "../../../components/OOILineField";
import AutoBox from "../../../components/input/AutoBox";
import { mapState } from "vuex";
import { eventBus, formatNumber } from "../../../plugins/global-funcs";
import Wysiwyg from "@/components/input/Wysiwyg.vue";
import Button from "@/components/input/Button.vue";

export default {
  name: "AFormOOI",
  components: {
    Button,
    Wysiwyg,
    TextField,
    TextArea,
    SwitchInset,
    AutoBox,
    OOILineField,
  },
  props: {
    masterData: {
      default: () => ({}),
    },
    isSameId: {
      default: false,
    },
  },
  data() {
    return {
      formatNumber,
      form: {
        dynamic_kpi: [],
      },
      tempBudget: {
        sub: [{ no: 1 }],
      },
      partTwoEditMode: false,
      OOIExpanded: true,
      OOI2Expanded: true,
      OOI4Expanded: true,
      resultExpanded: true,
      kpi: {},
      plan_code: "",
      OOIs: [
        {
          kpi_id: 60,
          kpi_name: "จำนวนผู้เข้าร่วมโครงการ IRTC ต่อปี",
          sub: [
            {
              kpi_sub_name: "มีผู้เข้าร่วมโครงการ IRTC ประเภทนิติบุคคล",
            },
          ],
        },
        {
          kpi_id: 61,
          kpi_name:
            "ผลกระทบเชิงเศรษฐกิจรวมที่เกิดขึ้นจาก IRTC ที่สามารถคำนวณได้ในปี",
          sub: [
            {
              kpi_sub_name: "มูลค่าของการเพิ่มกำลังการผลิต",
            },
            {
              kpi_sub_name: "มูลค่าของการลดต้นทุนในการผลิต",
            },
            {
              kpi_sub_name:
                "มูลค่าของการเพิ่มประสิทธิภาพหรือคุณภาพของผลิตภัณฑ์",
            },
            {
              kpi_sub_name:
                "มูลค่ายอดขายของผลิตภัณฑ์ที่เกิดขึ้นจริงหลังเข้าโครงการ",
            },
            {
              kpi_sub_name: "มูลค่าของกระบวนการผลิตใหม่ที่มีการผลิตจริง",
            },
          ],
        },
        {
          kpi_id: 62,
          kpi_name: "มูลค่าการลงทุน R&D ของผู้ประกอบการ IRTC ต่อปี",
          sub: [
            {
              kpi_sub_name: "ค่าใช้จ่ายที่เป็นเงินสด (in cash) ของโครงการ IRTC",
            },
            {
              kpi_sub_name:
                "ค่าใช้จ่ายที่เกี่ยวกับเครื่องมืออุปกรณ์วิจัยพัฒนาที่ใช้ในโครงการ",
            },
            {
              kpi_sub_name:
                "ค่าใช้จ่ายในการจัดทำหรือปรับปรุงสถานที่เพื่อดำเนินโครงการ",
            },
            {
              kpi_sub_name: "ค่าใช้จ่ายในการจ้างบุคลากรวิจัยรวมในปีที่ประเมิน",
            },
          ],
        },
        {
          kpi_id: 63,
          kpi_name:
            "คะแนนเฉลี่ยของระดับของเทคโนโลยีที่ผู้ประกอบการ IRTC นำมาใช้",
          sub: [
            {
              kpi_sub_name: "ระดับความสามารถของเทคโนโลยี (Functionality)",
            },
            {
              kpi_sub_name:
                "ระดับความก้าวหน้าของเทคโนโลยี (Newness, Advancement and Trend)",
            },
            {
              kpi_sub_name: "ระดับความง่ายในการใช้เทคโนโลยี (Usability)",
            },
            {
              kpi_sub_name:
                "ระดับการปรับขนาดไปสู่การผลิตเชิงพาณิชย์ (Scalability)",
            },
            {
              kpi_sub_name:
                "ระดับความสามารถในการแข่งขันของเทคโนโลยี (Competitiveness)",
            },
          ],
        },
      ],
      annexFiles: [],
      companyList: [],
      rulesFile: [
        (value) => !!value || "กรุณาแนบเอกสาร",
        (value) =>
          !value || value.size <= 50000000 || "ขนาดไฟล์ต้องน้อยกว่า 50 MB!",
      ],

      // incubation_companies
      is_incubation_company_form: false,
      incubation_companies: [],
      valid_incubation_company: true,
      university_masters: [],
      company_masters: [
        "อุตสาหกรรมยานยนต์สมัยใหม่ (Next-generation Automotive)",
        "อุตสาหกรรมอิเล็กทรอนิกส์อัจฉริยะ (Smart Electronics)",
        "อุตสาหกรรมการท่องเที่ยวกลุ่มรายได้ดีและการท่องเที่ยวเชิงสุขภาพ (Affluent, Medical and Wellness Tourism)",
        "การเกษตรและเทคโนโลยีชีวภาพ (Agriculture and Biotechnology)",
        "อุตสาหกรรมการแปรรูปอาหาร (Food for the Future)",
        "อุตสาหกรรมหุ่นยนต์ (Robotics)",
        "อุตสาหกรรมการบินและโลจิสติกส์ (Aviation and Logistics)",
        "อุตสาหกรรมเชื้อเพลิงชีวภาพและเคมีชีวภาพ (Biofuels and Biochemicals)",
        "อุตสาหกรรมดิจิตอล (Digital)",
        "อุตสาหกรรมการแพทย์ครบวงจร (Medical Hub)",
        "อุตสาหกรรมอื่น (ระบุ)",
      ],
      status_masters: [
        "บ่มเพาะธุระกิจ วทน. ปีที่ 1",
        "บ่มเพาะธุระกิจ วทน. ปีที่ 2",
        "บ่มเพาะธุระกิจ วทน. ปีที่ 3",
      ],
      incubation_companie_form: {
        fiscal_year: "",
        university_id: "",
        university_name: "",
        product: "",
        company: "",
        technology_type: "",
        technology_type_other: "",
        status: "",
      },
      incubationCompanyMainIndex: null,
      incubationCompanyIndex: null,
    };
  },
  computed: {
    ...mapState({
      OOIForm: (state) => state.CForm.OOIForm,
      isOIC: state => state.Auth.User.user_type === 'สป.อว.'
    }),
    total: function () {
      return this.calculateKPITotal();
    },
    isFinal() {
      return (
        this.$route.query.doc_type && this.$route.query.doc_type === "progress"
      );
    },
    yearList() {
      let year = new Date().getFullYear();
      let yearList = [];
      year = year + 543;
      for (let i = 0; i < 10; i++) {
        yearList.push(year - i);
      }
      return yearList;
    },
  },
  created() {
    if (this.masterData.form_b) {
      this.setData();
    }
    eventBus.$on("aFormOOI", () => {
      eventBus.$emit("aFormOOISend", {
        ...this.form,
        attachments: this.annexFiles || [],
        completed_incubation_company: this.companyList || [],
        incubation_companies:
          this.flattenNestedArray(this.incubation_companies) || [],
        kpi_sub_values: Object.values(this.kpi),
        dynamic_kpi: this.form.dynamic_kpi,
      });
    });

    eventBus.$on("aFormOOISetData", () => this.setData());

    this.university_masters = this.masterData.university_masters;

    // this.groupIncubationCompany(data);
  },
  methods: {
    removeVModel(item) {
      return JSON.parse(JSON.stringify(item));
    },
    addNewBudget() {
      this.tempBudget = {
        name: this.getNextIndicatorNumber(), // Auto set indicator number
        sub: [{ no: 1 }],
      };
      if (this.partTwoEditMode) {
        // clear temp index
        // this.clearTempPlan()

        this.$vuetify.goTo("#part-two-edit2");
      } else {
        // this.tempPlan.isNew = true
        this.partTwoEditMode = true;
      }
    },
    editBudget(index) {
      this.tempBudget = {
        ...this.removeVModel(this.form.dynamic_kpi[index]),
        temp_index: index,
      };
      this.partTwoEditMode = true;
    },

    // Get next auto increment indicator number starting from 82
    getNextIndicatorNumber() {
      if (!this.form.dynamic_kpi || this.form.dynamic_kpi.length === 0) {
        return '82';
      }

      // Find the highest existing number and increment by 1
      const maxNumber = Math.max(
        ...this.form.dynamic_kpi.map(item => parseInt(item.name) || 81)
      );

      return (maxNumber + 1).toString();
    },

    // Format amount for display with commas
    formatDisplayAmount(amount) {
      if (!amount || amount === '') return '';

      // Clean the value first
      const cleanValue = amount.toString().replace(/,/g, '');
      const numValue = parseFloat(cleanValue);

      if (!isNaN(numValue)) {
        return numValue.toLocaleString('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 10,
        });
      }

      return amount;
    },
    deleteBudget(index) {
      if (Array.isArray(this.form.dynamic_kpi)) {
        this.form.dynamic_kpi = this.form.dynamic_kpi.filter((_, i) => i !== index);

        // Update internal numbering (no field) after deletion
        this.form.dynamic_kpi.forEach((item, idx) => {
          item.no = idx + 1;
        });

        this.$forceUpdate();
      }
    },
    saveBudget() {
      this.partTwoEditMode = false;
      if (this.tempBudget.temp_index !== undefined) {
        // Edit mode - keep the same indicator number
        this.form.dynamic_kpi[this.tempBudget.temp_index] = this.removeVModel(
          this.tempBudget
        );
      } else {
        // Add mode - ensure indicator number is set
        if (!this.tempBudget.name) {
          this.tempBudget.name = this.getNextIndicatorNumber();
        }
        this.form.dynamic_kpi.push(this.tempBudget);
      }

      // Update internal numbering (no field) but keep indicator names unchanged
      this.form.dynamic_kpi.forEach((item, index) => {
        item.no = index + 1;
      });
      this.tempBudget = {};
      this.$forceUpdate();
    },
    addBudgetDetail() {
      if (!this.tempBudget.sub || this.tempBudget.sub.length === 0) {
        this.tempBudget.sub = [
          {
            no: 1,
          },
        ];
      } else {
        this.tempBudget.sub.push({
          no: this.tempBudget.sub.length + 1,
        });
      }
      console.log("test file", this.tempBudget.sub);
    },

    editDetailAmount(i, val, type) {
      if (type === "amount") {
        // Remove comma and store clean value
        const cleanVal = val.toString().replace(/,/g, '');
        this.tempBudget.sub[i].amount = cleanVal;
        // Force update to trigger formatting
        this.$forceUpdate();
      } else if (type === "currency") {
        this.tempBudget.sub[i].unit = val;
      }
    },
    getUniversityName() {
      const university = this.university_masters.find(
        (x) => x.id === this.incubation_companie_form.university_id
      );
      this.incubation_companie_form.university_name = university
        ? university.name_th
        : "";
    },

    clearIncubationCompanyForm() {
      this.incubation_companie_form = {
        fiscal_year: "",
        university_id: "",
        university_name: "",
        product: "",
        company: "",
        technology_type: "",
        technology_type_other: "",
        status: "",
      };
      this.incubationCompanyMainIndex = null;
      this.incubationCompanySubIndex = null;
      this.is_incubation_company_form = false;
    },

    handleSubmitIncubationCompanyForm() {
      if (this.$refs.incubation_company_form.validate()) {
        if (
          this.incubationCompanyMainIndex != null &&
          this.incubationCompanySubIndex != null
        ) {
          this.updateIncubationCompany();
        } else {
          this.saveIncubationCompany();
        }
      }
    },

    saveIncubationCompany() {
      // เพิ่มข้อมูลใน array ของ incubation_companies ตามปีที่เลือก
      const index = this.incubation_companies.findIndex((e) => {
        return e[0] == this.incubation_companie_form.fiscal_year;
      });

      if (index === -1) {
        // ไม่เจอปีที่เลือกใน array ให้เพิ่มปีนั้นเข้าไป
        this.incubation_companies.push([
          this.incubation_companie_form.fiscal_year,
          [this.incubation_companie_form],
        ]);
      } else {
        // ถ้าเจอปีที่เลือกใน array ให้เพิ่มข้อมูลในปีนั้น
        this.incubation_companies[index][1].push(this.incubation_companie_form);
      }

      // เรียงข้อมูลใหม่ จากมากไปน้อย เช่น 2566, 2565
      this.incubation_companies.sort((a, b) => b[0] - a[0]);

      // ล้างข้อมูลใน form
      this.clearIncubationCompanyForm();
    },

    updateIncubationCompany() {
      // แก้ไขข้อมูลใน array ของ incubation_companies ตามปีที่เลือก
      this.incubation_companies[this.incubationCompanyMainIndex][1][
        this.incubationCompanySubIndex
      ] = this.incubation_companie_form;

      // เรียงข้อมูลใหม่ จากมากไปน้อย เช่น 2566, 2565
      this.incubation_companies.sort((a, b) => b[0] - a[0]);

      // ล้างข้อมูลใน form
      this.clearIncubationCompanyForm();
    },
    unflattenArray(input) {
      const output = [];

      for (const obj of input) {
        const fiscalYear = obj.fiscal_year;
        let yearGroup = output.find((group) => group[0] === fiscalYear);

        if (!yearGroup) {
          yearGroup = [fiscalYear, []];
          output.push(yearGroup);
        }

        yearGroup[1].push(obj);
      }

      return output;
    },
    flattenNestedArray(input) {
      const output = [];

      for (const item of input) {
        for (const obj of item[1]) {
          output.push(obj);
        }
      }

      return output;
    },
    editIncubationCompany(mainIndex, subIndex) {
      this.incubationCompanyMainIndex = mainIndex;
      this.incubationCompanySubIndex = subIndex;
      this.incubation_companie_form =
        this.incubation_companies[mainIndex][1][subIndex];
      this.incubation_companie_form.fiscal_year = this.incubation_companie_form
        .fiscal_year
        ? parseInt(this.incubation_companie_form.fiscal_year)
        : null;
      this.is_incubation_company_form = true;
    },

    deleteIncubationCompany(mainIndex, subIndex) {
      this.incubation_companies[mainIndex][1].splice(subIndex, 1);

      // เช็คว่าถ้าข้อมูลในปีนั้นเป็นค่าว่างหมด ให้ลบปีนั้นออก
      if (this.incubation_companies[mainIndex][1].length === 0) {
        this.incubation_companies.splice(mainIndex, 1);
      }
    },

    setFormField(field, val) {
      this.form[field] = val;
      this.$forceUpdate();
    },
    setData() {
          if (this.masterData.form_b.form_ab_general_info) {
        this.form = this.masterData.form_b.form_ab_general_info;
        this.$set(this.form, "dynamic_kpi", this.masterData.form_b.form_ab_general_info.dynamic_kpi || []);
      }
      for (const x of this.masterData.kpi_masters) {
        for (const y of x.kpi_sub_masters) {
          if (y.kpi_sub_values) {
            let subId = y.kpi_sub_values.kpi_sub_master_id.toString();
            this.kpi[subId] = {};
            this.kpi[subId].id = y.kpi_sub_values.id;
            this.kpi[subId].kpi_sub_master_id =
              y.kpi_sub_values.kpi_sub_master_id;
            this.kpi[subId].kpi_sub_value = y.kpi_sub_values.kpi_sub_value;
            this.kpi[subId].description = y.kpi_sub_values.description;
          }
        }
      }
      this.plan_code = this.masterData.plan_master.plan_code;
    },
    setKpiField(subId, val) {
      // format {
      //   kpi_sub_master_id: '',
      //   kpi_sub_value: ''
      // }
      // this.kpi[subId] = {}
      if (!this.kpi[subId]) this.kpi[subId] = {};
      this.kpi[subId].kpi_sub_master_id = subId;
      this.kpi[subId].kpi_sub_value = val;
      this.$forceUpdate();
    },
    checkLessThanBefore(subId) {
      if (this.isFinal && (this.$route.query.id || this.masterData.updateId)) {
        // progress/final and update case
        let oldVal = this.masterData.form_b.kpi_sub_values_inception?.find(
          (x) => x.kpi_sub_master_id == subId
        )?.kpi_sub_value;
        if (oldVal && this.kpi[subId].kpi_sub_value < oldVal) {
          this.kpi[subId].kpi_sub_value = oldVal;
          console.log(
            "Cannot input less than before, value has been rollback."
          );
          this.$forceUpdate();
        }
      }
    },
    setKpiDescription(subId, val) {
      if (!this.kpi[subId]) this.kpi[subId] = {};
      this.kpi[subId].description = val;
      this.$forceUpdate();
    },
    // Calculate sum by each KPI item
    calculateKPITotal: function (item) {
      let itemTotal = 0;
      switch (item.no) {
        case "64":
        case "65":
          if (item.kpi_sub_masters.length >= 2) {
            if (
              this.kpi[item.kpi_sub_masters[0].id] &&
              this.kpi[item.kpi_sub_masters[1].id]
            ) {
              if (this.kpi[item.kpi_sub_masters[1].id].kpi_sub_value == 0) {
                itemTotal = 0;
              } else {
                itemTotal =
                  (Number(this.kpi[item.kpi_sub_masters[0].id].kpi_sub_value) /
                    Number(this.kpi[item.kpi_sub_masters[1].id].kpi_sub_value) * 100).toFixed(2);
              }
            }
          }
          break;
        // Other Case
        default:
          item.kpi_sub_masters.forEach((sub, index) => {
            if (index !== item.kpi_sub_masters.length - 1 && this.kpi[sub.id]) {
              itemTotal += Number(this.kpi[sub.id].kpi_sub_value);
            }
          });
          break;
      }

      // call setKpiField with the id of the last kpi_sub_master and the calculated itemTotal
      let lastSub = item.kpi_sub_masters[item.kpi_sub_masters.length - 1];
      if (
        lastSub &&
        lastSub.id &&
        (!this.kpi[lastSub.id] ||
          this.kpi[lastSub.id].kpi_sub_value != itemTotal)
      ) {
        this.setKpiField(lastSub.id, itemTotal);
      }

      return itemTotal;
    },
    addAnnexFile() {
      this.annexFiles.push({});
    },
    addToAttachment(index, file) {
      if (file.size > 50000000) {
        this.$store.commit('General/setModal', {
          title: 'ขนาดไฟล์เกิน 50 MB',
          theme: 'warning',
          text: 'กรุณาแนบไฟล์ที่มีขนาดไม่เกิน 50 MB',
          showCancel: false,
          buttonText: 'ตกลง'
        })
        this.annexFiles.pop()
        return
      }

      this.annexFiles[index] = file;
      this.$forceUpdate();
    },
    checkValType(val) {
      return typeof val;
    },
    selectFile(id) {
      // querySelector id file จากนั้นเรียก event click
      document.querySelector("#file" + id).click();
    },
    removeFile(id) {
      this.annexFiles.splice(id, 1);
      this.$forceUpdate();
    },
    addCompanyList() {
      this.companyList.push({
        participants_year: "",
        participants_count: "",
      });
    },
    addToCompany(index, field, file) {
      this.companyList[index][field] = file;
      this.form.completed_incubation_company = this.companyList;
      this.$forceUpdate();
    },
    removeCompany(id) {
      console.log("before remove", this.companyList);
      this.companyList.splice(id, 1);
      this.form.completed_incubation_company = this.companyList;
      console.log("after remove", this.companyList);
      this.$forceUpdate();
    },
    autoField() {
      this.form = {
        ...this.form,
        indicator_economy: "ตัวอย่างในเชิงเศรษฐกิจ",
        result_economy: "ตัวอย่างด้านเศรษฐกิจ",
        result_society: "ตัวอย่างด้านสังคม",
        result_environment: "ตัวอย่างด้านสิ่งแวดล้อม",
      }
      this.form.dynamic_kpi.push(
        {
          "sub": [
            {
              "no": 1,
              "name": "1",
              "amount": "1",
              "unit": "หน่วย"
            }
          ],
          "name": "1",
          "unit": "ทดสอบหัวข้อ",
          "no": 1
        })
    }
  },
};
</script>

<style lang="scss">
.incubation_companie_form {
  label {
    font-weight: 500;
    font-size: 14px;
    color: #000000;
  }

  .v-input__slot,
  .v-text-field.v-text-field--solo .v-input__control {
    min-height: 40px !important;
    border-radius: 30px;
  }

  .v-text-field--full-width .v-input__prepend-outer,
  .v-text-field--full-width .v-input__prepend-inner,
  .v-text-field--full-width .v-input__append-inner,
  .v-text-field--full-width .v-input__append-outer,
  .v-text-field--enclosed .v-input__prepend-outer,
  .v-text-field--enclosed .v-input__prepend-inner,
  .v-text-field--enclosed .v-input__append-inner,
  .v-text-field--enclosed .v-input__append-outer {
    margin-top: 8px !important;
  }

  .v-input--is-readonly:not(.picker-field) .v-input__slot {
    background-color: #ffffff !important;
  }

  i.v-icon.notranslate.mdi.mdi-calendar.theme--light {
    color: #f7941d !important;
  }
}
</style>
